export const TOKEN = '__user_token__'
export const USERDATA = '__user_data__'

export const isDevelopment = process.env.NODE_ENV === 'development'

export const isProduction = !isDevelopment
